<template>
	<p v-if="text" class="brand_seo_summary">{{ text }}</p>
</template>

<script>
import { buildBrandSummary } from "@/lib/brandSeo";

/**
 * 브랜드 상세 첫 문단. 브랜드명·카드명·할인율·대상 카드·적용 범위(매장 수/온라인)를 보이는 텍스트로 넣는다.
 * 검색 결과 요약(AI 오버뷰 포함)이 뽑아갈 수 있는 고유 문장이며 호스트(카드)별로 달라진다.
 * 문장 규칙은 src/lib/brandSeo.js(buildBrandSummary). 같은 문장이 JSON-LD(setBrandJsonLd)에도 들어간다.
 * kbprm·narasarang 도 같은 구성으로 보여 준다. 심의 문구 조각(siteProfiles 의 subject·payWith·mechanism·closing)만 끼워 넣는다.
 */
export default {
	name: "BrandSeoSummary",
	props: {
		/** brandName, benefit, brandType, storeCnt 를 가진 객체 */
		brand: { type: Object, default: () => ({}) },
		/** { alt: '국민카드' } 형태의 대상 카드 배열 */
		cards: { type: Array, default: () => [] },
	},
	computed: {
		text() {
			return buildBrandSummary(this.brand, this.cards);
		},
	},
};
</script>
